<vectronic-filter-header
  [title]="title()"
  (titleClicked)="onToggle()"
  (enabledFilterToggle)="onToggle()"
  [isFilterEnabled]="value() === true"
></vectronic-filter-header>
